/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Badge } from 'ui/atoms/Badge/Badge';
import { IconBadge } from 'ui/atoms/IconBadge/IconBadge';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './IntegrationCard.module.scss';

import type { IntegrationCardProps } from './IntegrationCard.types';

export const IntegrationCard = ({
  icon,
  iconBadge,
  toolName,
  company,
  category,
  description,
  plans,
  href,
  extra,
  layout = 'horizontal',
  className,
}: IntegrationCardProps) => {
  const isVertical = layout === 'vertical';

  const content = (
    <>
      <header className={styles.header}>
        {icon && <Icon type={icon} className={styles.icon} />}

        {iconBadge && <IconBadge iconType={iconBadge} color="white" border />}

        {!isVertical && (
          <div className={styles.meta}>
            <h3 className={styles.name}>{toolName}</h3>

            {(company || category) && (
              <span className={styles.source}>
                {company} · {category}
              </span>
            )}
          </div>
        )}
      </header>

      {isVertical && <h3 className={styles.name}>{toolName}</h3>}

      <p className={styles.description}>{description}</p>

      {plans && plans.length > 0 && (
        <footer className={styles.plans}>
          {plans.map((plan) => (
            <Badge key={plan}>{plan}</Badge>
          ))}
        </footer>
      )}

      {extra && <div className={styles.extra}>{extra}</div>}
    </>
  );

  if (href) {
    return (
      <a href={href} className={cn(styles.card, styles.card_link, isVertical && styles.card_vertical, className)}>
        {content}
      </a>
    );
  }

  return <article className={cn(styles.card, isVertical && styles.card_vertical, className)}>{content}</article>;
};
